export default "__VITE_ASSET__BOXBWFuN__"